import React from 'react';
import { compose, setDisplayName, lifecycle } from 'recompose';
import cn from 'classnames';

import styles from './style.css';
import Profile from '../profile';
import Links from '../links';
import ActionCenter from '../action-center';

const UserNav = compose(
  lifecycle({
    componentDidMount() {
      !window._infl && (window._infl = {
        currentContact: this.props.profile
      });
    }
  }),
  setDisplayName('UserNav')
)(({ profile, features, hubSwitcher, unseenCounts, moment, unseenNotificationsCount, enabledFeatures }) => (
  <div className={cn(styles.nav, 'c-header-nav-wrapper')}>
    <Links features={features} />
    <div className={cn(styles.actionsContainer, 'c-nav-details-container')}>
      <ActionCenter
        points={profile.attributes.points.current}
        moment={moment}
        unseenNotificationsCount={unseenNotificationsCount} />
      <Profile
        features={features}
        profile={profile}
        hubSwitcher={hubSwitcher}
        unseenCounts={unseenCounts}
        enabledFeatures={enabledFeatures} />
    </div>
  </div>
));

export default UserNav;
